import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const HeaderContainer = styled.header`
  background-color: #f5f5dc;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  position: sticky;
  top: 0;
  z-index: 100;
`;

const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 1rem;
  }
`;

const Logo = styled.div`
  h1 {
    font-size: 1.8rem;
    color: #8b4513;
    margin: 0;
  }
`;

const NavLinks = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;

  @media (max-width: 768px) {
    margin-top: 1rem;
  }

  li {
    margin-left: 2rem;

    @media (max-width: 768px) {
      margin-left: 1rem;
      margin-right: 1rem;
    }
  }

  a {
    color: #8b4513;
    text-decoration: none;
    font-weight: bold;
    transition: color 0.3s;
    position: relative;

    &:hover {
      color: #d2691e;
    }

    &.active {
      color: #d2691e;

      &::after {
        content: '';
        position: absolute;
        bottom: -5px;
        left: 0;
        width: 100%;
        height: 2px;
        background-color: #d2691e;
      }
    }
  }
`;

const MobileMenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #8b4513;

  @media (max-width: 768px) {
    display: block;
  }
`;

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <HeaderContainer as={motion.header} initial={{ y: -100 }} animate={{ y: 0 }} transition={{ duration: 0.5 }}>
      <Nav>
        <Logo>
          <Link to="/">
            <h1>Sweet Delights Bakery</h1>
          </Link>
        </Logo>
        <MobileMenuButton onClick={toggleMobileMenu}>
          {isMobileMenuOpen ? '✕' : '☰'}
        </MobileMenuButton>
        <NavLinks style={{ display: isMobileMenuOpen ? 'flex' : 'flex' }}>
          <motion.li whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }}>
            <Link to="/" onClick={() => setIsMobileMenuOpen(false)}>Home</Link>
          </motion.li>
          <motion.li whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }}>
            <Link to="/gallery" onClick={() => setIsMobileMenuOpen(false)}>Gallery</Link>
          </motion.li>
          <motion.li whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }}>
            <Link to="/about" onClick={() => setIsMobileMenuOpen(false)}>About</Link>
          </motion.li>
          <motion.li whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }}>
            <Link to="/contact" onClick={() => setIsMobileMenuOpen(false)}>Contact</Link>
          </motion.li>
        </NavLinks>
      </Nav>
    </HeaderContainer>
  );
};

export default Header;